import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from "../sidebar/sidebar.component";
import { Router } from '@angular/router';
import { AuthService, DashboardConfiguration, PermissionsEnum } from 'shared-lib';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: false
})
export class MainLayoutComponent {
  isSidebarExpanded: boolean = false;
  PermissionsEnum = PermissionsEnum;
  DashboardConfiguration = DashboardConfiguration;

  constructor(public authService: AuthService, private router: Router) {}

  onMouseEnter() {
    this.isSidebarExpanded = true;
  }

  onMouseLeave() {
    this.isSidebarExpanded = false;
  }
}
